import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedNumber, IntlProvider } from 'react-intl';
import { Row, Col, OverlayTrigger, Popover, Alert, DropdownButton, MenuItem, Clearfix } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import GoogleMap from 'google-map-react';
import scriptLoader from 'react-async-script-loader';

import { getOrderLabels } from 'helpers/order';

import Breadcrumb from 'components/layout/Breadcrumb';
import OrderActions from 'components/layout/order/OrderActions';
import OrderItemsCustomer from 'components/layout/order/OrderItemsCustomer';
import OrderInvoicesPopover from 'components/layout/order/OrderInvoicesPopover';
import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import IntlDateTime from 'components/layout/IntlDateTime';
import MapMarker from 'components/layout/MapMarker';
import WorkingHours from 'components/layout/client/WorkingHours';

import Data from 'components/Data';

import { GOOGLE_MAPS_KEY, GOOGLE_MAPS_URL, mapOptions } from 'js/constants';

class OrderViewCustomer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showLocationInfos: false,
    };
  }

  getOrderTitle = () => {
    const {
      intl: { messages },
      orderData,
      data,
    } = this.props;

    const order = orderData || data.data;

    switch (order.type) {
      case 'car_rent': {
        return (
          <h4>
            {messages.orderTypes.car_rent}{' '}
            <span class="hint-text">
              <IntlDateTime date={order.date_from} /> - <IntlDateTime date={order.date_to} />
            </span>
          </h4>
        );
      }

      case 'car_sales': {
        return <h4>{messages.orderTypes.car_sales}</h4>;
      }

      case 'item_sales': {
        return <h4>{messages.orderTypes.item_sales}</h4>;
      }
    }

    return null;
  };

  showLocationInfos = e => {
    e.preventDefault();
    this.setState({ showLocationInfos: true });
  };

  closeLocationInfos = e => {
    e.preventDefault();
    this.setState({ showLocationInfos: false });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      layout,
      orderId,
      orderData,
      data,
      user,
      isScriptLoaded,
    } = this.props;

    const pending = orderData ? false : data.pending;
    const order = orderData || data.data;

    if (!isScriptLoaded) {
      return <Loader />;
    }

    let orderActionListItemComponent = null;
    let orderActionsWrapperComponent = null;
    if (!pending && layout.breakpointIndex < 2) {
      const SimpleMenuItemActionElement = ({ key, caption, icon, action }) => (
        <MenuItem key={key} eventKey={key} onClick={action}>
          <i class={'fa-fw ' + icon + ' m-r-5'} /> {caption}
        </MenuItem>
      );
      orderActionListItemComponent = <SimpleMenuItemActionElement />;
      orderActionsWrapperComponent = (
        <DropdownButton id={'input-dropdown-addon-' + order.id} noCaret pullRight title={<i class="fal fa-bars" />} />
      );
    }

    const orderActions = pending ? null : (
      <OrderActions
        order={order}
        wrapperComponent={orderActionsWrapperComponent}
        listItemComponent={orderActionListItemComponent}
        key={'order-actions' + order.id}
      />
    );

    let gMapsUrl = 'https://www.google.com/maps/search/?api=1&query=';
    if (!pending && this.state.showLocationInfos && (order.type === 'car_rent' || order.type === 'car_service')) {
      gMapsUrl +=
        order.pickup_location.street +
        ' ' +
        order.pickup_location.house_number +
        ' ' +
        order.pickup_location.apartment_number +
        ', ' +
        order.pickup_location.zip_code +
        ' ' +
        order.pickup_location.city;
    }

    let headerName = messages.order_details;
    let typeIdName = messages.order;
    let orderDateName = messages.order_placed;
    let currentBreadcrumbName = messages.orders;
    let currentBreadcrumbLink = appIntl.urlPrefix + 'account/orders';
    if (!pending && order.type === 'car_service') {
      headerName = messages.service_details;
      typeIdName = messages.car_service_appointment;
      orderDateName = messages.car_service_booked_at;
      currentBreadcrumbName = messages.car_service_appointments;
      currentBreadcrumbLink = appIntl.urlPrefix + 'account/carServices';
    }

    return (
      <div class="padding-25 sm-padding-10 relative">
        {orderData !== undefined ? (
          <Data dataName="order" />
        ) : (
          <Data dataName="order" url={`/api/orders/${orderId}.json`} data={data} />
        )}

        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: currentBreadcrumbLink, name: currentBreadcrumbName },
            { link: null, name: order.id },
          ]}
        />

        {pending ? (
          <Loader />
        ) : (
          <div>
            <h3>
              {getOrderLabels(order, messages)} {headerName}
            </h3>

            <div class="panel b-rad-lg no-overflow b-grey">
              <div class="bg-master-lightest menuclipper padding-20 sm-padding-10">
                <Row>
                  <Col xs={12} sm={6}>
                    <span class="hidden-sm hidden-md hidden-lg block">
                      {typeIdName} #{order.id}
                    </span>
                    {orderDateName} <IntlDate date={order.cdate} />
                    <span class="m-l-10 m-r-10 hint-text hidden-xs">|</span>
                    <span class="hidden-xs">
                      {typeIdName} #{order.id}
                    </span>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div class="text-right xs-text-left">
                      <OverlayTrigger
                        container={this}
                        trigger="click"
                        rootClose
                        placement="bottom"
                        overlay={
                          <Popover id={'order-invoices-' + order.id}>
                            <IntlProvider locale={appIntl.locale} messages={appIntl.messages.messages}>
                              <OrderInvoicesPopover order={order} />
                            </IntlProvider>
                          </Popover>
                        }
                      >
                        <a href="javascript:;" class="inline">
                          <span class="text-primary">{messages.salesDoc.invoice}</span> <i class="fas fa-angle-down" />
                        </a>
                      </OverlayTrigger>
                    </div>
                  </Col>
                </Row>
              </div>
              <div class="panel-body">
                <Row>
                  <Col xs={12} md={4}>
                    <div class="m-b-5 bold">{messages.shipping_address}</div>
                    <div class="">
                      {order.target.profile.company ? order.target.profile.company : null}{' '}
                      {order.target.profile.company ? <br /> : null}
                      {order.target.profile.first_name} {order.target.profile.last_name}
                      <br />
                      {order.target.profile.street} {order.target.profile.house_number}{' '}
                      {order.target.profile.apartment_number}
                      <br />
                      {order.target.profile.zip_code} {order.target.profile.city}
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    {order.type !== 'car_service' && (
                      <React.Fragment>
                        <div class="m-b-5 bold">{messages.payment_method}</div>
                        <div class="">{messages['payment_' + order.payment]}</div>
                      </React.Fragment>
                    )}
                  </Col>
                  <Col xs={12} md={4}>
                    {order.type !== 'car_service' && (
                      <React.Fragment>
                        <div class="m-b-5 bold">{messages.order_overview}</div>
                        <div class="">
                          <div class="clearfix">
                            <div class="pull-left" />
                            <div class="pull-right" />
                          </div>

                          <div class="clearfix">
                            <div class="pull-left">{messages.salesDoc.amount_due}</div>
                            <div class="pull-right">
                              <FormattedNumber value={order.sum_net} style="currency" currency={order.currency} />
                            </div>
                          </div>

                          {order.vat_sum_rates.map(vatRate => {
                            return (
                              <div class="clearfix" key={vatRate.rate}>
                                <div class="pull-left">
                                  {order.vat_name} ({vatRate.rate}%)
                                </div>
                                <div class="pull-right">
                                  <FormattedNumber value={vatRate.sum} style="currency" currency={order.currency} />
                                </div>
                              </div>
                            );
                          })}

                          <div class="clearfix m-t-5">
                            <div class="pull-left bold">{messages.salesDoc.total}</div>
                            <div class="pull-right bold">
                              <FormattedNumber value={order.sum_gross} style="currency" currency={order.currency} />
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </Col>
                </Row>
              </div>
            </div>

            <div class="panel b-rad-lg no-overflow b-grey">
              <div class="panel-body">
                <Row>
                  <Col sm={12} md={8} class="relative">
                    {layout.breakpointIndex < 2 ? <div class="top-right">{orderActions}</div> : null}

                    {/* order title */}
                    {this.getOrderTitle()}

                    {(order.type === 'car_rent' || order.type === 'car_service') && (
                      <React.Fragment>
                        <Alert class="flex-display">
                          <p class="mr-auto col-xs-6 no-padding">
                            <span class="bold">
                              <i class="fal fa-map-marked" />{' '}
                              {order.type === 'car_rent' ? messages.pick_up_and_drop_off : messages.service_location}:
                            </span>
                            <br />
                            {order.pickup_location.name}, {order.pickup_location.street}{' '}
                            {order.pickup_location.house_number} {order.pickup_location.apartment_number},{' '}
                            {order.pickup_location.zip_code} {order.pickup_location.city}
                          </p>
                          <p class="bold no-margin">
                            {this.state.showLocationInfos ? (
                              <a href="#closeLocationDetails" onClick={this.closeLocationInfos}>
                                × {messages.less_infos}
                              </a>
                            ) : (
                              <a href="#showLocationDetails" onClick={this.showLocationInfos}>
                                {messages.more_infos}
                              </a>
                            )}
                          </p>
                          <Clearfix />
                        </Alert>
                        <AnimateHeight duration={300} height={this.state.showLocationInfos ? 'auto' : 0}>
                          <div class="p-t-10 p-b-20">
                            <Row class="m-b-10">
                              <Col xs={6}>
                                {messages.formGroup.opening_hours}:<br />
                                {order.type === 'car_rent' && (
                                  <WorkingHours
                                    data={order.pickup_location.working_week_rental_point}
                                    timezone={user.profile.timezone}
                                  />
                                )}
                                {order.type === 'car_service' && (
                                  <WorkingHours
                                    data={order.pickup_location.working_week_service_point}
                                    timezone={user.profile.timezone}
                                  />
                                )}
                              </Col>
                              <Col xs={6}>
                                <div class="text-right">
                                  <a href={gMapsUrl} class="btn btn-default" target="_blank">
                                    <i class="fal fa-external-link" /> {messages.open_in_google_maps}
                                  </a>
                                </div>
                              </Col>
                            </Row>

                            <div style={{ height: '300px' }}>
                              <GoogleMap
                                bootstrapURLKeys={{
                                  key: GOOGLE_MAPS_KEY,
                                  language: appIntl.locale,
                                }}
                                defaultCenter={{
                                  lat: order.pickup_location.coordinates.lat,
                                  lng: order.pickup_location.coordinates.lng,
                                }}
                                center={{
                                  lat: order.pickup_location.coordinates.lat,
                                  lng: order.pickup_location.coordinates.lng,
                                }}
                                defaultZoom={15}
                                options={mapOptions}
                              >
                                <MapMarker
                                  lat={order.pickup_location.coordinates.lat}
                                  lng={order.pickup_location.coordinates.lng}
                                />
                              </GoogleMap>
                            </div>
                          </div>
                        </AnimateHeight>
                      </React.Fragment>
                    )}

                    {/* item list */}
                    <OrderItemsCustomer order={order} />
                  </Col>
                  <Col xsHidden smHidden md={4} class="p-t-30">
                    {layout.breakpointIndex > 1 ? orderActions : null}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
OrderViewCustomer.defaultProps = {};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
    data: state.data.order,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(scriptLoader(GOOGLE_MAPS_URL)(OrderViewCustomer))));
